var _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOxygen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.515,
    height: 40.163,
    viewBox: "0 0 41.515 40.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.082,
    cy: 15.082,
    rx: 15.082,
    ry: 15.082,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.082,
    cy: 15.082,
    rx: 13.582,
    ry: 13.582,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.515 36.163)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.288,
    y: 0
  }, "2"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxygen);
export default __webpack_public_path__ + "static/media/oxygen.f79fb3614b491adf21a32ae8bcfb7aad.svg";
export { ForwardRef as ReactComponent };